
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.49 21.678c0-4.6-1.2-8.9-6.6-9.5-3.8-.4-7.8 0-11.6 0-5 0-10-.1-15 0-4.8.1-7.8 2.5-8.1 7.5-.3 4.9-.2 10 0 15 .2 5.4 2.7 8.3 8 8.6v4.1c0 .2.2 2 .9 1.5 2.8-2 5.6-5.2 9-5.6 5.1-.5 10.4.1 15.5 0 10.8-.4 7.9-14.3 7.9-21.6zm-1.4 13.8c-.9 5.6-7.4 4.5-11.5 4.5-3.5 0-8.6-1-12 0-2.3.7-4.9 3.2-7 5v-2.9c.1-.9-.1-2.1-.7-2.1-3.2 0-6.6-.6-7.3-4.4-.2-1.3 0-2.9 0-4.2 0-3.7-.5-7.8 0-11.5.7-5.1 5.6-4.6 9.4-4.6h13.2c3.3 0 6.8-.2 10.1 0 5.9.4 5.7 4.6 5.7 9.1.1 3.5.7 7.6.1 11.1z"}})])
          )
        }
      }
    